import React, { useState } from "react";
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Paper,
  Divider,
  CircularProgress,
} from "@mui/material";
import { PageBar } from "../../CommonComponents";
import Button from "@mui/material/Button";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const Index = () => {
  const [selectedValue, setSelectedValue] = useState("fnv_prices");
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleGenerateSheet = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `https://g5rizhvq4t7vxpblmd5jhy6lqu0zraff.lambda-url.ap-south-1.on.aws/`,
        { report_type: selectedValue },
        {
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.body?.url) {
        setLoading(false);
        toast.success("Google sheet downloaded successfully", {
          position: "top-right",
        });
        window.open(response?.data?.body?.url, "_blank");
      } else {
        setLoading(false);
        toast.error(response?.data?.body?.message || "Something went wrong", {
          position: "top-right",
        });
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      toast.error(err || "Something went wrong", { position: "top-right" });
    }
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#EEF2F7",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        {loading && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
          >
            <CircularProgress color="primary" />
          </Box>
        )}
        <PageBar text="OCP : View Prices" />
        <Box sx={{ p: 3, maxWidth: "90%", margin: "auto" }}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography
              fontWeight={600}
              variant="h6"
              color="primary"
              gutterBottom
            >
              View Active Prices & Offers
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <RadioGroup
              sx={{ marginLeft: "4rem" }}
              value={selectedValue}
              onChange={handleChange}
            >
              <FormControlLabel
                value="fnv_prices"
                control={<Radio color="primary" />}
                label={
                  <Typography fontWeight={600}>FNV Active Prices</Typography>
                }
              />
              <Divider sx={{ mt: 2 }} />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginTop: "2rem",
                }}
              >
                <FormControlLabel
                  value="curr_price_ch"
                  control={<Radio />}
                  label={
                    <Typography fontWeight={600}>
                      Price Change Report (yesterday's changed)
                    </Typography>
                  }
                  sx={{ flex: 1 }}
                />
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ mx: 6, height: 30, width: 2 }}
                />
                <FormControlLabel
                  value="all_active"
                  control={<Radio />}
                  label={
                    <Typography fontWeight={600}>
                      All Active Prices & Offers
                    </Typography>
                  }
                  sx={{ flex: 1 }}
                />
              </Box>
              <Box
                sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
              >
                <FormControlLabel
                  value="curr_dis_price"
                  control={<Radio />}
                  label={
                    <Typography fontWeight={600}>
                      Disabled Offers (yesterday's changed)
                    </Typography>
                  }
                  sx={{ flex: 1 }}
                />
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ mx: 6, height: 30, width: 2 }}
                />
                <FormControlLabel
                  value="nm_prices"
                  control={<Radio />}
                  label={
                    <Typography fontWeight={600}>
                      Price & Active Offers (next month)
                    </Typography>
                  }
                  sx={{ flex: 1}}
                />
              </Box>
            </RadioGroup>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: loading ? "#A1C9FF" : "#0160F1",
                  cursor: loading ? "not-allowed" : "pointer",
                }}
                onClick={handleGenerateSheet}
                disabled={loading}
              >
                Generate Google Sheet
              </Button>
            </Box>
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default Index;
